import React from "react";
import { useTranslation } from "react-i18next";

export const StatusIndicator = ({ status, onClose, outputFormat }) => {
  const { t } = useTranslation();
  const isMarkdown = outputFormat === "markdown";

  if (!status.loading && !status.success && !status.error) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md">
      {status.loading && (
        <div
          className="p-4 rounded-lg shadow-lg"
          style={{
            backgroundColor: "var(--background)",
            border: "1px solid var(--primary-300)",
            color: "var(--text-800)",
          }}
        >
          <div className="flex gap-3 items-center">
            <div className="w-5 h-5 rounded-full border-2 animate-spin border-primary-500 border-t-transparent"></div>
            <span className="font-medium">
              {t(
                isMarkdown
                  ? "pdfGenerator.status.generatingMarkdown"
                  : "pdfGenerator.status.generatingPdf",
              )}
            </span>
          </div>
        </div>
      )}

      {status.success && (
        <div
          className="p-4 rounded-lg shadow-lg"
          style={{
            backgroundColor: "var(--background)",
            border: "1px solid var(--accent-300)",
            color: "var(--text-800)",
          }}
        >
          <div className="flex gap-3 justify-between items-center">
            <div className="flex gap-2 items-center">
              <span className="text-green-500">✅</span>
              <span className="font-medium">
                {t(
                  isMarkdown
                    ? "pdfGenerator.status.successMarkdown"
                    : "pdfGenerator.status.successPdf",
                )}
              </span>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 transition-colors hover:text-gray-600"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {status.error && (
        <div
          className="p-4 rounded-lg shadow-lg"
          style={{
            backgroundColor: "var(--background)",
            border: "1px solid #ef4444",
            color: "var(--text-800)",
          }}
        >
          <div className="flex gap-3 justify-between items-center">
            <div className="flex gap-2 items-start">
              <span className="text-red-500">❌</span>
              <div>
                <div className="font-medium">
                  {t(
                    isMarkdown
                      ? "pdfGenerator.status.errorMarkdown"
                      : "pdfGenerator.status.errorPdf",
                  )}
                </div>
                {status.message && (
                  <div className="mt-1 text-sm text-red-600">
                    {status.message}
                  </div>
                )}
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 transition-colors hover:text-gray-600"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
